export enum EntityTypes {
  "LLP" = "Limited Liability Partnership (LLP)",
  "LLC" = "Limited Liability Company (LLC)",
  "SCORP" = "S-Corporation",
  "CCORP" = "C-Corporation",
  "OTHER" = "Other"
}